<template>
    <transition>
  <keep-alive>
    <router-view/>
  </keep-alive>
           
     
       
    </transition>
</template>
<script>
export default {
    name:'itil-layout'
}
</script>